import React from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useRecoilValue } from "recoil";
import {
  VideoIconAndTypography,
  IconAndTypographyContainer,
  VideoPlayContainer,
  StyledPlayVideo,
  VideoDiv,
} from "./VideoEmbed.styles";
import unityMother from "../../../assets/images/unityMother.png";
import { GetTypographyContent } from "../Typography/Typography";
import { useDeviceHook } from "../../../utils/hooks/useDeviceHook";
import { SendActionType } from "../Services/SharedServices";
import { getUserAuth } from "../../../recoil/selectors";

const DEFAULT_VIMEO_URL =
  "https://player.vimeo.com/video/589930889?h=54814c7b52#t=0m0s";

const VideoEmbed: React.FC<{
  overlayText: React.ReactNode;
  requisitionID?: string;
  onPlay?: () => void | Promise<void>;
  url?: string;
  lightImage?: boolean | string;
}> = ({
  overlayText,
  requisitionID,
  onPlay,
  url = DEFAULT_VIMEO_URL,
  lightImage,
}) => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();
  const auth = useRecoilValue(getUserAuth);

  const handleOnPlay = React.useCallback(async () => {
    if (onPlay) {
      onPlay();
    } else if (requisitionID) {
      SendActionType("ViewedDashboardVideo", requisitionID, auth?.access_token);
    }
  }, [onPlay, requisitionID, auth?.access_token]);

  const videoOverlay = (
    <VideoPlayContainer deviceType={deviceType}>
      {GetTypographyContent({
        content: overlayText,
        size: "h3",
        textColor: "white",
        isBold: true,
        padding: "10px",
      })}
      <IconAndTypographyContainer>
        <VideoIconAndTypography>
          <StyledPlayVideo />
          {GetTypographyContent({
            content: t("landing.videoOverlay.watchVideo"),
            size: "xlarge",
            textColor: "white",
            isBold: true,
          })}
        </VideoIconAndTypography>
      </IconAndTypographyContainer>
    </VideoPlayContainer>
  );

  return (
    <VideoDiv>
      <ReactPlayer
        playing
        url={url}
        playIcon={videoOverlay}
        light={lightImage !== undefined ? lightImage : unityMother}
        height={`${deviceType !== "mobile" ? "100%" : "328px"}`}
        width="100%"
        controls
        data-testid="unity-video-player"
        onPlay={handleOnPlay}
      />
    </VideoDiv>
  );
};

export default VideoEmbed;
